import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetOffersFromHistoryLoading, EGetOffersFromHistoryActionType } from './types';

export const getOffersFromHistoryLoading: () => TGetOffersFromHistoryLoading =
  actionGenerator<EGetOffersFromHistoryActionType.Loading>(EGetOffersFromHistoryActionType.Loading);
